import styled from "styled-components";
import html2canvas from "html2canvas";
import { Link } from "react-router-dom";
import { BiUpArrowAlt, BiDownArrowAlt } from "react-icons/bi";
import { IoTicket } from "react-icons/io5";

const Tabela = styled.table`
    width: 90%;
    justify-content: center;
    text-align: center;
    border-collapse: collapse;
    margin: auto;
    margin-top: 10px;
    overflow-x: auto;
`
const TituloColunas = styled.th`
    color: #252525;

    p {
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        margin: 0;
        cursor: pointer;
    }
    .Icone {
        position: relative;
        top: 4px;
        left: 3px;
        margin: 0 2px;
        padding: 0;
        cursor: pointer;
    }
`
const LinhaTabela = styled.tr`
    border-bottom: 1px solid lightgray;
    height: 30px;
`
const ColunaTabela = styled.td`
    width: ${props => props.$tamanho || "auto"};
    .Icone {
        position: relative;
        top: 4px;
        left: 3px;
        margin: 0 2px;
        padding: 0;
        cursor: pointer;
    }
`

export function TabelaCupons(cupons, ordenacaoAtual, ordemAtual, atualizaParametro, cupomRef, setCupomAtual) {
    // Inicializa array com os campos a serem mostrados na tabela
    const campos = [
        { chave: "codigo", label: "Código" },
        { chave: "dataCriacao", label: "Criação" },
        { chave: "jaUtilizado", label: "Utilizado" },
        { chave: "dataUtilizacao", label: "Usado em" },
        { chave: "visitante", label: "Visitante" },
        { chave: "origem", label: "Origem" }
    ];

    // Função para atualizar a ordem ou ordenação ao clicar no título de uma coluna
    function atualizaOrdemOrdenacao(ordenacao) {
        // Se clicou em um coluna cuja ordenação já é a atual, apenas inverte a ordem
        if (ordenacaoAtual === ordenacao) {
            atualizaParametro("ordem", ordemAtual === "1" ? "-1" : "1");
        } else {
            atualizaParametro("ordenacao", ordenacao);
        }
    }

    // Função para baixar imagem do cupom
    function salvarCupom(codigo, data) {
        let dataValidade = new Date(data);
        dataValidade.setDate(dataValidade.getDate() + 180);

        try {
            setCupomAtual({
                codigo,
                validade: formatarData(dataValidade).substring(0, 10)
            });

            setTimeout(() => {
                html2canvas(cupomRef.current, { scale: 2 }).then((canvas) => {
                    const link = document.createElement("a");
                    link.download = `cupom-${codigo}.png`;
                    link.href = canvas.toDataURL("image/png");
                    link.click();
                });
            }, 100);
        } catch (e) {
            console.log(e.message);
        }
    }

    try {
        return (<Tabela>
            <thead>
                <LinhaTabela>
                    {campos.map(campo => {
                        return <TituloColunas key={campo.chave} onClick={() => atualizaOrdemOrdenacao(campo.chave)}>
                            <p>
                                {campo.label}
                                {campo.chave === ordenacaoAtual && ordemAtual === "-1" && <BiUpArrowAlt className="Icone" size={'1em'} />}
                                {campo.chave === ordenacaoAtual && ordemAtual === "1" && <BiDownArrowAlt className="Icone" size={'1em'} />}
                            </p>
                        </TituloColunas>
                    })}
                    <TituloColunas>Ações</TituloColunas>
                </LinhaTabela>
            </thead>
            <tbody>
                {cupons.map((cupom) => {
                    // Cria Date com a data criação
                    let dataCriacao = new Date(cupom.dataCriacao);

                    // Cria Date com a data de utilização se existir
                    let dataUtilizacao = null;
                    if (cupom.dataUtilizacao) {
                        dataUtilizacao = new Date(cupom.dataUtilizacao);
                    }

                    return (<LinhaTabela key={cupom._id}>
                        <ColunaTabela style={{ cursor: "pointer" }}>
                            <Link style={{ textDecoration: 'none', color: "inherit" }} to={`/admin/cupons/${cupom._id}`}>{`${cupom.codigo.slice(0, 3)} ${cupom.codigo.slice(3)}` || "-"}</Link>
                        </ColunaTabela>
                        <ColunaTabela style={{ cursor: "pointer" }}>
                            {formatarData(dataCriacao) || "-"}
                        </ColunaTabela>
                        <ColunaTabela style={{ cursor: "pointer" }}>
                            {cupom.jaUtilizado ? "Sim" : "Não"}
                        </ColunaTabela>
                        <ColunaTabela>
                            {dataUtilizacao ? formatarData(dataUtilizacao) : "-"}
                        </ColunaTabela>
                        <ColunaTabela>
                            <Link style={{ textDecoration: 'none', color: "inherit" }} to={`/admin/visitantes/${cupom.visitante._id}`}>{cupom.visitante.nome.split(" ")[0] || cupom.visitante.email || cupom.visitante.celular || "-"}</Link>
                        </ColunaTabela>
                        <ColunaTabela>
                            {cupom.origem || "-"}
                        </ColunaTabela>
                        <ColunaTabela>
                            <IoTicket className="Icone" onClick={() => salvarCupom(cupom.codigo, cupom.dataCriacao)} />
                        </ColunaTabela>
                    </LinhaTabela>)
                })}
            </tbody>
        </Tabela>)
    } catch (e) {
        console.log(e.message)
        return <></>
    }
}

function formatarData(date) {
    const dia = String(date.getDate()).padStart(2, "0");
    const mes = String(date.getMonth() + 1).padStart(2, "0");
    const ano = date.getFullYear();

    const hora = String(date.getHours()).padStart(2, "0");
    const minuto = String(date.getMinutes()).padStart(2, "0");
    const segundo = String(date.getSeconds()).padStart(2, "0");

    return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
}